module.exports = __webpack_public_path__ + "static/media/logo_esn_small_fr.6ee30121.svg";